// Sound effects manager using Web Audio API
class SoundManager {
  constructor() {
    this.audioContext = null;
    this.initialized = false;
  }

  init() {
    if (this.initialized) return;
    try {
      this.audioContext = new (window.AudioContext || window.webkitAudioContext)();
      this.initialized = true;
    } catch (e) {
      console.warn('Web Audio API not supported');
    }
  }

  // Check if sound is muted
  isMuted() {
    return localStorage.getItem('footparadise_sound_muted') === 'true';
  }

  // Key click sound - soft tap
  playKeyClick() {
    if (this.isMuted()) return;
    if (!this.audioContext) this.init();
    if (!this.audioContext) return;

    try {
      const oscillator = this.audioContext.createOscillator();
      const gainNode = this.audioContext.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(this.audioContext.destination);

      oscillator.frequency.setValueAtTime(800, this.audioContext.currentTime);
      oscillator.frequency.exponentialRampToValueAtTime(400, this.audioContext.currentTime + 0.05);
      
      oscillator.type = 'sine';
      
      gainNode.gain.setValueAtTime(0.1, this.audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, this.audioContext.currentTime + 0.05);

      oscillator.start(this.audioContext.currentTime);
      oscillator.stop(this.audioContext.currentTime + 0.05);
    } catch (e) {
      console.warn('Error playing key click:', e);
    }
  }

  // Success/unlock sparkle sound
  playUnlockSuccess() {
    if (this.isMuted()) return;
    if (!this.audioContext) this.init();
    if (!this.audioContext) return;

    try {
      // Play a magical ascending arpeggio
      const notes = [523.25, 659.25, 783.99, 1046.50]; // C5, E5, G5, C6
      const startTime = this.audioContext.currentTime;

      notes.forEach((freq, index) => {
        const oscillator = this.audioContext.createOscillator();
        const gainNode = this.audioContext.createGain();

        oscillator.connect(gainNode);
        gainNode.connect(this.audioContext.destination);

        oscillator.frequency.setValueAtTime(freq, startTime + index * 0.08);
        oscillator.type = 'sine';

        const noteStart = startTime + index * 0.08;
        gainNode.gain.setValueAtTime(0, noteStart);
        gainNode.gain.linearRampToValueAtTime(0.15, noteStart + 0.02);
        gainNode.gain.exponentialRampToValueAtTime(0.01, noteStart + 0.3);

        oscillator.start(noteStart);
        oscillator.stop(noteStart + 0.3);
      });

      // Add a sparkle/shimmer effect
      setTimeout(() => this.playSparkle(), 200);
    } catch (e) {
      console.warn('Error playing unlock success:', e);
    }
  }

  // Sparkle/shimmer sound
  playSparkle() {
    if (this.isMuted()) return;
    if (!this.audioContext) return;

    try {
      for (let i = 0; i < 5; i++) {
        setTimeout(() => {
          const oscillator = this.audioContext.createOscillator();
          const gainNode = this.audioContext.createGain();

          oscillator.connect(gainNode);
          gainNode.connect(this.audioContext.destination);

          const baseFreq = 2000 + Math.random() * 2000;
          oscillator.frequency.setValueAtTime(baseFreq, this.audioContext.currentTime);
          oscillator.frequency.exponentialRampToValueAtTime(baseFreq * 0.5, this.audioContext.currentTime + 0.1);
          
          oscillator.type = 'sine';
          
          gainNode.gain.setValueAtTime(0.05, this.audioContext.currentTime);
          gainNode.gain.exponentialRampToValueAtTime(0.001, this.audioContext.currentTime + 0.1);

          oscillator.start(this.audioContext.currentTime);
          oscillator.stop(this.audioContext.currentTime + 0.1);
        }, i * 50);
      }
    } catch (e) {
      console.warn('Error playing sparkle:', e);
    }
  }

  // Error sound
  playError() {
    if (this.isMuted()) return;
    if (!this.audioContext) this.init();
    if (!this.audioContext) return;

    try {
      const oscillator = this.audioContext.createOscillator();
      const gainNode = this.audioContext.createGain();

      oscillator.connect(gainNode);
      gainNode.connect(this.audioContext.destination);

      oscillator.frequency.setValueAtTime(200, this.audioContext.currentTime);
      oscillator.frequency.linearRampToValueAtTime(150, this.audioContext.currentTime + 0.15);
      
      oscillator.type = 'square';
      
      gainNode.gain.setValueAtTime(0.1, this.audioContext.currentTime);
      gainNode.gain.exponentialRampToValueAtTime(0.01, this.audioContext.currentTime + 0.15);

      oscillator.start(this.audioContext.currentTime);
      oscillator.stop(this.audioContext.currentTime + 0.15);
    } catch (e) {
      console.warn('Error playing error sound:', e);
    }
  }
}

export const soundManager = new SoundManager();
